<div id="warningZone" *ngIf="opened">
  <div class="alert alert-warning" role="alert">
    <span>
      <i class="fa fa-exclamation-circle marginRight5" aria-hidden="true"></i>
    </span>
    <strong id="message">{{ text }}</strong>
  </div>
</div>
